import React, { useContext } from 'react';
import { FaEnvelope, FaInstagram, FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import { LanguageContext } from '../../../contexts/LanguageContext';
import {
  RESTAURANT_EMAIL,
  RESTAURANT_PHONE,
  RESTAURANT_PHONE_DISPLAY,
  RESTAURANT_WHATSAPP_DISPLAY,
  RESTAURANT_WHATSAPP_URL,
} from '../../../constants/contact';
import '../../Footer/css/Footer.css';

const navItems = ['home', 'about', 'menu', 'location'];

const Footer = () => {
  const { t } = useContext(LanguageContext);
  const year = new Date().getFullYear();

  return (
    <footer className="footer-container">
      <div className="footer-inner">
        <div className="footer-brand">
          <h3>Vatti Taverna</h3>
          <p>{t('footerTagline')}</p>
        </div>

        <nav className="footer-nav" aria-label="Footer navigation">
          {navItems.map((item) => (
            <a key={item} href={`#${item}`}>
              {t(item)}
            </a>
          ))}
        </nav>

        <div className="footer-contact">
          <a href={`tel:${RESTAURANT_PHONE}`}>
            <FaPhoneAlt aria-hidden="true" />
            {RESTAURANT_PHONE_DISPLAY}
          </a>

          <a href={RESTAURANT_WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
            <FaWhatsapp aria-hidden="true" />
            {RESTAURANT_WHATSAPP_DISPLAY}
          </a>

          <a href={`mailto:${RESTAURANT_EMAIL}`}>
            <FaEnvelope aria-hidden="true" />
            {RESTAURANT_EMAIL}
          </a>

          <a href="https://instagram.com/the_vatti" target="_blank" rel="noopener noreferrer">
            <FaInstagram aria-hidden="true" />
            Instagram
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {year} Vatti Taverna. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
